import React, { useEffect, useState, useCallback } from 'react';
import { InputNumber } from 'antd';

import style from './index.less';

type Prop = {
  value: string;
  className?: string;
  onChange?(timeStr: string): void;
  unit?: string;
};

const InputNumberRange: React.FC<Prop> = ({ className = '', value = '', onChange, unit = '' }) => {
  const [start, setStart] = useState<string | number>('');
  const [end, setEnd] = useState<string | number>('');

  const onStartChange = useCallback(e => {
    setStart(e);
  }, []);

  const onEndChange = useCallback(e => {
    setEnd(e);
  }, []);

  useEffect(() => {
    if (typeof start === 'number' && typeof end === 'number' && onChange) {
      onChange(`${start}~${end}`);
    }
  }, [start, end]);

  useEffect(() => {
    const valueList = value.toString().split('~');
    if (value && /\d~\d+$/.test(value.toString()) && valueList.length) {
      setStart(parseInt(valueList[0], 10));
      setEnd(parseInt(valueList[1], 10));
    } else {
      setStart('');
      setEnd('');
    }
  }, [value]);

  useEffect(() => {
    return () => {
      setStart('');
      setEnd('');
    };
  }, []);

  return (
    <div className={`${className} ${style.range}`}>
      <div className={style.range_flex}>
        <InputNumber
          onChange={onStartChange}
          value={typeof start === 'string' ? window.parseInt(start, 10) : start}
          className={style.range_num}
          min={0}
        />

        <div className={style.center}>{'至'}</div>
        <InputNumber
          onChange={onEndChange}
          value={typeof end === 'string' ? window.parseInt(end, 10) : end}
          className={style.range_num}
          min={0}
        />
      </div>
      {unit ? <div className={style.unit}>{unit}</div> : null}
    </div>
  );
};

export default InputNumberRange;
